import { UIKitIcon } from '../icon';

export const settingsIcon: UIKitIcon = {
  name: 'settings',
  // tslint:disable-next-line: max-line-length
  data: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32" height="32" viewBox="0 0 32 32"> '
  + '<g> <path fill="none" stroke="inherit" d="M12,14L12,14c-1.1,0-2,0.9-2,2l0,0c0,1.1,0.9,2,2,2l0,0c1.1,0,2-0.9,2-2l0,0C14,14.9,13.1,14,'
  + '12,14z"/> <path fill="none" stroke="inherit" d="M24,10L24,10z"/> <path fill="none" stroke="inherit" d="M8,16h2"/> <path fill="none" '
  + 'stroke="inherit" d="M14,16h10"/> <path fill="none" stroke="inherit" d="M20,22L20,22z"/> <path fill="none" stroke="inherit" '
  + 'd="M20,24L20,24c1.1,0,2-0.9,2-2l0,0c0-1.1-0.9-2-2-2l0,0c-1.1,0-2,0.9-2,2l0,0C18,23.1,18.9,24,20,24z"/> <path fill="none" '
  + 'stroke="inherit" d="M24,22h-2"/> <path fill="none" stroke="inherit" d="M18,22H8"/> <path fill="none" stroke="inherit" '
  + 'd="M20,12L20,12c1.1,0,2-0.9,2-2l0,0c0-1.1-0.9-2-2-2l0,0c-1.1,0-2,0.9-2,2l0,0C18,11.1,18.9,12,20,12z"/> <path fill="none" '
  + 'stroke="inherit" d="M24,10h-2"/> <path fill="none" stroke="inherit" d="M18,10H8"/> </g> </svg> ',
};
